import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'Context/QueryClientContext';
import toastHandler from 'Utils/toastHandler';
import { STAGES_QUERY_KEY } from 'Data/keys/QueryKeys';
import { ObrasApiV2 } from 'Data/Obras.api.v2';
import { IConstructionSiteStageLibraryRequest } from 'Data/interfaces/Obra/IObraLibraries';
import { IStage } from 'Data/interfaces/Obra/IObraStages';

export const useQueryImportLibrary = () => {
  const { mutate, isPending } = useMutation({
    mutationFn: (variables: IConstructionSiteStageLibraryRequest) => {
      return ObrasApiV2.importLibrary(variables);
    },
    onSuccess: async (data, variables) => {
      await queryClient.cancelQueries({
        queryKey: [STAGES_QUERY_KEY, variables.constructionSiteId],
      });

      queryClient.setQueryData<IStage[]>(
        [STAGES_QUERY_KEY, variables.constructionSiteId],
        data.data,
      );

      toastHandler.showSuccess('Biblioteca importada com sucesso!');
    },
    onError: (error: any) => {
      const errorMsg = error.errors
        ? error.errors[0].Message
        : 'Erro ao importar Biblioteca!';
      toastHandler.showError(errorMsg);
    },
  });

  return {
    importLibrary: mutate,
    isLoading: isPending,
  };
};
